import { UpdateUserInput, UpdateUserMutationVariables } from '@/API';
import {
  UpdateUserMutation,
  updateUserWithConnection as updateUserMutation,
} from '@/appsync/graphql/user';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';

export const updateUser = async (user: UpdateUserInput): Promise<void> => {
  const variables: UpdateUserMutationVariables = {
    input: user,
  };

  await graphqlQuery<UpdateUserMutation, UpdateUserMutationVariables>(
    updateUserMutation,
    variables
  );
};
